import { render } from "./ClockCreate.vue?vue&type=template&id=2ffaf6ba&scoped=true"
import script from "./ClockCreate.vue?vue&type=script&lang=js"
export * from "./ClockCreate.vue?vue&type=script&lang=js"

import "./ClockCreate.vue?vue&type=style&index=0&id=2ffaf6ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffaf6ba"]])

export default __exports__